module.exports = __webpack_public_path__ + "static/media/12.68e025cc.jpg";